module.exports = __webpack_public_path__ + "fonts/FuturaStd-Book.f33aa1dd.eot";